import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HorizontalTabsElement from './HorizontallTabsElement/HorizontalTabsElement';
import shallowEqual from 'fbjs/lib/shallowEqual';
import {getDynamicRefById} from 'crazyEditor/core/elements/utils/elementRefUtils';
import _ from 'lodash';

function getChildrenOffset(elementId) {
  return getDynamicRefById(elementId).refs.tabs.getChildrenOffset();
}

function getSelectedTabId(elementId) {
  return getDynamicRefById(elementId).refs.tabs.getSelectedTabId();
}

function getEditBoxStyles(elementProps, childElementProps) {
  const backgroundColor = _.get(elementProps, 'data.childrenProps.compProps.backgroundColor', 'white');
  const compProps = _.omit(childElementProps.compProps, ['zIndex']);
  return {...compProps, backgroundColor, margin: elementProps.compProps.borderWidth};
}

// get styles of elements that have a cursor: pointer
function getInteractiveElements(elementId) {
  const elementRef = getDynamicRefById(elementId);
  if (elementRef) {
    return elementRef.refs.tabs.getInteractiveElements();
  }
  return [];
}

class TabsElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    return (
      <HorizontalTabsElement ref="tabs" {...this.props}/>
    );
  }
}

export default {
  elementClass: TabsElement,
  methods: {
    getChildrenOffset,
    getInteractiveElements,
    getSelectedTabId,
    getEditBoxStyles,
  }
};